<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel">Cancel</ion-button>
      </ion-buttons>
      <ion-title>Communications Error</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="cancel" :strong="true">Done</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-item>
      <ion-label class="ion-text-center">
        <h1>Error</h1>
      </ion-label>
    </ion-item>
    <div v-if="appearOffline.length > 0">
      <ion-item color="warning">
        {{ appearOffline }}
    </ion-item>
    </div>
    <ion-item>
     {{ iosTop }}
    </ion-item>
    <ion-item>
     Program: {{ props.program }}
    </ion-item>
    <ion-item>
     Error: {{ message }}
    </ion-item>
    <ion-item>
     {{ iosBottom }}
    </ion-item>
  </ion-content>
</template>

<script  setup>
  import {
    IonRange,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    IonInput,
    IonLabel,
    modalController,
  } from '@ionic/vue';
  import { defineComponent, ref } from 'vue';
  import { t , replaceMultipleAll } from '@/composables/translateText.js'

  const props = defineProps({
    type : String, 
    program : String,
    errorMessage : null
	})

  const isOffline = !navigator.onLine
  const appearOffline = ref( (isOffline) ? t("Note: your device might be off-line") : "")

  const iosTop = ref(t("Chessvis had the following error while communicating with its on-line server"))
  const iosBottom = ref(t("If this persists and is not associated with your connectivity, please let us know at: support@chessvis.com"))

  const message = ref((typeof props.errorMessage === "object") ? 
                        JSON.stringify(props.errorMessage) : props.errorMessage)
  const name = ref();

  const cancel = () => modalController.dismiss(null, 'cancel');
  const confirm = () => modalController.dismiss(value, 'confirm');

</script>
